import { updateRequestProfile } from '../../../../../../api'
import { REQUEST_PROFILE_CHANGE_TYPE } from '../../../../../../constants/request'
import { useNotification } from '../../../../../../hooks'
import { useRequestProfileContext } from '../../../../RequestProfile.hooks'
import { getRequestProfilePatchMergeData } from '../../../../RequestProfile.utils'
import { getRequestProfileWidgetSideWorkersInitialValues } from '../../RequestProfileWidgetSideWorkers.utils'

export function useRequestProfileWidgetSideWorkersData({ requestId }) {
  const {
    handleMergeEntityData,
    handleReloadAfterChange,
    outboundUuid,
    requestSideWorkers,
  } = useRequestProfileContext()

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  async function handleSubmit({ payload }) {
    return updateRequestProfile({ data: payload, id: requestId, outboundUuid })
      .then(({ data }) => {
        handleAddSuccessNotification('Notification.CommonTitleSavedKey')
        handleMergeEntityData(getRequestProfilePatchMergeData(data))

        return handleReloadAfterChange(REQUEST_PROFILE_CHANGE_TYPE.providers)
      })
      .catch(() => {
        handleAddErrorNotification('Error.CommonApiRequestFailKey')
      })
  }

  const formInitialValues =
    getRequestProfileWidgetSideWorkersInitialValues(requestSideWorkers)

  return { formInitialValues, handleSubmit }
}
